import { locales, defaultLocale } from '@/i18n/config';

/**
 * Añade el prefijo de idioma a un href interno (`/guias` -> `/ca/guias`).
 * No toca enlaces externos, anclas, ni hrefs que ya llevan prefijo.
 *
 * Vive en su propio módulo, sin `'use client'`, para que puedan usarla tanto
 * los componentes de cliente (LocaleLink) como los server components (el
 * guard del blog, que redirige al home del idioma actual). Importarla desde
 * LocaleLink.tsx en el servidor arrastraría un módulo cliente entero.
 */
export function localizeHref(href: string, locale: string): string {
  if (!href.startsWith('/') || href.startsWith('//')) return href;
  if (locale === defaultLocale) return href;
  const firstSeg = href.split('/')[1]?.split('?')[0].split('#')[0];
  if (firstSeg && (locales as readonly string[]).includes(firstSeg)) {
    return href; // ya lleva prefijo de idioma
  }
  return href === '/' ? `/${locale}` : `/${locale}${href}`;
}
